import { isPublicRoutePath, isRemovedOneStopListingRoutePath } from "~/utils/publicRoute";

export default defineNuxtRouteMiddleware((to, _from) => {
  if (isRemovedOneStopListingRoutePath(to.path)) {
    return abortNavigation(
      createError({
        statusCode: 404,
        statusMessage: "One Stop listing page removed",
      }),
    );
  }

  if (isPublicRoutePath(to.path)) {
    return;
  }

  let token = "";
  if (import.meta.client) {
    token = localStorage.getItem("token") || "";
  }

  if (!token) {
    return navigateTo({
      path: "/login",
      query: {
        code: 401,
        redirect: to.fullPath,
        message: "Please login first.",
      },
    });
  }
});
